import script from "./tab-slide.vue?vue&type=script&setup=true&lang=js"
export * from "./tab-slide.vue?vue&type=script&setup=true&lang=js"

import "./tab-slide.vue?vue&type=style&index=0&id=3658a1e3&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3658a1e3"]])

export default __exports__